import { useSelector } from 'react-redux';
import UserProfile from '../UserProfile/UserProfile'; 
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import Logout from '../Logout/Logout';
import DeleteAccount from '../DeleteAccount/DeleteAccount';
import MyAthletesPanelToggleButton from '../MyAthletesPanelToggleButton/MyAthletesPanelToggleButton';
import logo from '../../assets/GymnazeLogoLightMode.png';
import styles from './Header.module.css';

const Header = ({ onOpenAthletesPanel }) => {
  const role = useSelector((state) => state.auth.role);
  const isCoach = role === 'coach';

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <img src={logo} alt="Gymnaze" className={styles.logo} />
        {isCoach && (
          <MyAthletesPanelToggleButton onClick={onOpenAthletesPanel} />
        )}
      </div>
      <div className={styles.right}>
        <DeleteAccount />
        <Logout />
        <ThemeToggle />
        <UserProfile />
      </div>
    </header>
  );
};

export default Header;